<div class="cv-datepicker-two-component datepicker-two-container">
    <p-calendar
        [(ngModel)]="value"
        placeholder="{{placeholder}}"
        dateFormat="{{dateFormat}}"
        inputId="{{inputId}}"
        name="{{name}}"
        ariaLabelledBy="{{ariaLabelledBy}}"
        iconAriaLabel="{{iconAriaLabel}}"
        [required]="required"
        [disabled]="disabled"
        selectionMode="{{selectionMode}}"
        [maxDateCount]="maxDateCount"
        [showIcon]="true"
        [showClear]="showClear"
        [showTime]="showTime"
        [showButtonBar]="showButtonBar"
        [inline]="inline"
        (onSelect)="onValueChange($event)"
        (onClear)="clearValue()"
        icon="{{icon}}"
        [readonlyInput]="true"
        [touchUI]="touchUI"
        [inputStyle]="{ 'padding-left': showClear ? '29px' : '12px'}"
        [ngClass]="{'p-calendar-required' : required, 'p-calendar-valid': !valid}"
        [numberOfMonths]="numberOfMonths"
        [showWeek]="showWeekNumbers"
        [showOtherMonths]="showOtherMonths"
        [selectOtherMonths]="selectOtherMonths"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [disabledDates]="disabledDates"
        [disabledDays]="disabledDays"
        [timeOnly]="timeOnly"
        [showSeconds]="showSeconds"
        [stepHour]="stepHour"
        [stepMinute]="stepMinute"
        [stepSecond]="stepSecond"
        [hourFormat]="hourFormat"
        [timeSeparator]="timeSeparator"
        [multipleSeparator]="multipleSeparator"
        [rangeSeparator]="rangeSeparator"
        [view]="view"
        appendTo="body"
        >
    </p-calendar>
</div>
